import { Close } from '../../design-system';
import { SleekButton } from '../../theme';

type Props = {
  onClose: () => void;
  /** False once the order's last pack is open: Vault / Sell end the reveal. */
  canClose: boolean;
  /** 0-based pack on screen and the order's size; "Pack i/N" shows from 2 up. */
  packIndex: number;
  packCount: number;
};

/**
 * Sleek reveal top bar (partner feedback 2026-10-01): only the close control,
 * flush left at every width, and the order's progress centred — no skip /
 * mute switches and no balance, the ceremony is one swipe.
 *
 * The close goes the moment the last pack is sliced open (partner Loom
 * 2026-10-14): Vault and Sell leave the reveal there anyway. It turns
 * invisible rather than unmounting, so the bar keeps its height and the
 * progress does not move.
 */
export function SleekRevealTopBar({ onClose, canClose, packIndex, packCount }: Props) {
  return (
    <div className="absolute top-4 inset-x-4 z-30 flex items-center">
      <SleekButton
        name="RevealCloseButton"
        onClick={onClose}
        aria-label="Exit"
        className={canClose ? '' : 'invisible'}
      >
        <Close size={16} />
      </SleekButton>
      {packCount > 1 && (
        <span
          data-co-component="RevealPackProgress"
          className="pointer-events-none absolute inset-x-0 text-center text-[18px] font-medium leading-[24px] tracking-[-0.44px] text-[var(--co-RevealPackProgress-color,#FFFFFF)]"
        >
          Pack {packIndex + 1}/{packCount}
        </span>
      )}
    </div>
  );
}
